'use client';
import { PropsWithChildren } from 'react';
import { LngLatBoundsLike, MapProvider } from 'react-map-gl/mapbox';

import { MapStateProvider } from 'src/hooks/useMapState';

type Props = PropsWithChildren<{
    accessToken: string;
    defaultBounds?: LngLatBoundsLike;
}>;

export default function InternalMapProvider({ accessToken, defaultBounds, children }: Props) {
    return (
        <MapProvider>
            <MapStateProvider accessToken={accessToken} defaultBounds={defaultBounds}>
                {children}
            </MapStateProvider>
        </MapProvider>
    );
}
